const SYNC_STATUS_KEY_PREFIX = 'syncStatus_';
const LAST_SYNC_TIME_KEY_PREFIX = 'lastSyncTime_';

export function clearProjectSyncSessionCache() {
  try {
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (
        key?.startsWith(SYNC_STATUS_KEY_PREFIX)
        || key?.startsWith(LAST_SYNC_TIME_KEY_PREFIX)
      ) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch (error) {
    console.error('Error clearing project sync session cache:', error);
  }
}

function resolveIdAfterSync(items, storedId, sessionNameKey, getItemName) {
  if (!storedId) return storedId;

  const list = Array.isArray(items) ? items : [];
  const matchById = list.find((item) => String(item?._id) === String(storedId));
  if (matchById) return matchById._id;

  const storedName = sessionStorage.getItem(sessionNameKey);
  if (!storedName) return storedId;

  const matchByName = list.find((item) => getItemName(item) === storedName);
  return matchByName?._id ?? storedId;
}

export function resolveSprintIdAfterSync(sprints, sprintId) {
  return resolveIdAfterSync(sprints, sprintId, 'sprintName', (sprint) => sprint?.name);
}

export function resolveReleaseIdAfterSync(releases, releaseId) {
  return resolveIdAfterSync(
    releases,
    releaseId,
    'releaseName',
    (release) => release?.releaseName,
  );
}
